import Image from './Image';
import { ImageProps } from './types';

export default Image;
export type { ImageProps };
